export const generateSubmissionFlowId = (): string => crypto.randomUUID();
